import { Chip, Tooltip } from '@mui/material';

function ToolbarToggleChip({
  checked,
  onChange,
  label,
  tooltip,
  size = 'small',
  colorWhenOn = 'primary',
}) {
  const chip = (
    <Chip
      size={size}
      clickable
      label={label}
      color={checked ? colorWhenOn : 'default'}
      variant={checked ? 'filled' : 'outlined'}
      onClick={() => onChange(!checked)}
      sx={{
        fontWeight: 600,
        borderRadius: 999,
        userSelect: 'none',
      }}
    />
  );

  return tooltip ? <Tooltip title={tooltip}>{chip}</Tooltip> : chip;
}

export default ToolbarToggleChip;

